import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { JobTitlesGridProps } from '../interfaces';
import { JobTitleCard } from './JobTitleCard';

export const JobTitlesGrid = ({
  jobTitles,
  currentPage,
  itemsPerPage,
  searchQuery,
  onDelete,
}: JobTitlesGridProps) => {
  if (jobTitles.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
          {searchQuery
            ? 'No job titles found matching your search.'
            : 'No job titles yet. Add one above!'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        gap: 1.5,
        p: 2,
      }}
    >
      {jobTitles.map((jobTitle, index) => (
        <JobTitleCard
          key={jobTitle.value}
          jobTitle={jobTitle}
          index={index}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          onDelete={onDelete}
        />
      ))}
    </Box>
  );
};
